/**
 * API de configuración comida al granel (bulk.php)
 * Configuraciones con valor umbral y acumulado
 */

import { dotoniwoofApi } from '../api/dotoniwooApi';

const BASE = '/bulk.php';

/**
 * GET /config - Lista configuraciones con acumulado
 */
export const getBulkConfigs = async () => {
  try {
    const response = await dotoniwoofApi.get(`${BASE}/config`);
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      data: data?.data ?? data?.message ?? []
    };
  } catch (error) {
    console.error('Error al obtener configuraciones granel:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * GET /config/{id_item} - Detalle de una configuración
 */
export const getBulkConfigById = async (idItem) => {
  try {
    const response = await dotoniwoofApi.get(`${BASE}/config/${idItem}`);
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      data: data?.data ?? data
    };
  } catch (error) {
    console.error('Error al obtener configuración:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * POST /config - Crear o actualizar configuración
 * @param {Object} payload - { firebase_UID, id_item, threshold_value, notes? }
 */
export const postBulkConfig = async (payload) => {
  try {
    const response = await dotoniwoofApi.post(`${BASE}/config`, payload);
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      code: data?.code,
      data: data
    };
  } catch (error) {
    console.error('Error al guardar configuración granel:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al guardar' }
    };
  }
};

/**
 * GET /accum?id_item= - Acumulado actual de un ítem
 */
export const getBulkAccum = async (idItem) => {
  try {
    const response = await dotoniwoofApi.get(`${BASE}/accum`, { params: { id_item: idItem } });
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      data: data?.data ?? data
    };
  } catch (error) {
    console.error('Error al obtener acumulado:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
